<template>
  <div style>
    <div
      @click.stop="doShowBottomClick"
      id="mb_fullscreen"
      class="my-mobile-video-class"
      style="display: flex;position: relative"
    >
      <div
        style="display: flex;width: 100%;height: 500px"
        :style="{height:videoHeight?videoHeight+'px':'unset'}"
      >
        <!---carouselPoster组件 最开始显示图片展位 -->
        <template v-if="isweixinenv">
          <!-- autoplay -->
          <video
            controls="true"
            :src="sourceData"
            :id="'mobileVideo'+componentIndex"
            :muted="voiceOff"
            width="100%"
            style="width: 100%;height: 100%"
            loop
            :poster=" sourceData.indexOf('lqEs7uG5Ib-GDlTOnLqzxNob-yiV')>-1?tempCover:sourceData+videoStr"
            preload="auto"
          
            x-webkit-airplay="true"
            playsinline="true"
            webkit-playsinline="true"
          ></video>
        </template>
        <template v-else>
          <template v-if="!imgLoaded&&showCom=='carouselPoster'">
          <img style="width:100%;height:100%" :src="sourceData+videoStr" />
        </template>
        <template v-else>
          <video
            v-if="!isWechatLike"
            :id="'mobileVideo'+componentIndex"
            @click.stop="doShowBottomClick('mobileVideo'+componentIndex)"
            :controls="isweixinenv"
            :muted="voiceOff"
            loop
            autoplay
            preload="auto"
            :poster="sourceData.indexOf('lqEs7uG5Ib-GDlTOnLqzxNob-yiV')>-1?tempCover:sourceData+videoStr"
            x-webkit-airplay="true"
            playsinline="true"
            webkit-playsinline="true"
            style="width: 100%;height: 100%"
            :src="sourceData"
          />
          <video
            :controls="showControls||(isweixinenv)"
            :src="sourceData"
            :id="'mobileVideo'+componentIndex"
            :muted="voiceOff"
            width="100%"
            style="width: 100%;height: 100%"
            loop
            :poster=" sourceData.indexOf('lqEs7uG5Ib-GDlTOnLqzxNob-yiV')>-1?tempCover:sourceData+videoStr"
            preload="auto"
            autoplay
            x-webkit-airplay="true"
            playsinline="true"
            webkit-playsinline="true"
            v-if="isWechatLike"
          ></video>
        </template>
        </template>
        
        <template v-if="singlePlay">
          <div
            @click="voiceOff = !voiceOff"
            v-if="useVideoController"
            :class="{'mb-bottom-control-box-show':showBottomController, 'mb-bottom-control-box-hide':!showBottomController}"
            class="audio-icon-box"
          >
            <img v-if="!voiceOff" src="../../../assets/image/icon/video_voice_on.png" />
            <img v-if="voiceOff" src="../../../assets/image/icon/video_voice_off.png" />
          </div>
        </template>
        <template v-else>
          <div
            v-if="!isWechatLike"
            @click.stop="doShowBottomClick"
            style="width: 100%"
            :class="{'mb-bottom-control-box-show':showBottomController, 'mb-bottom-control-box-hide':!showBottomController}"
            class="mb-bottom-control-box"
          >
            <div class="mb-video-icon" @click.stop="playOrPauseClick('mobileVideo'+componentIndex)">
              <img v-if="playingVideo" src="../../../assets/image/icon/video_pause_icon.png" />
              <img v-if="!playingVideo" src="../../../assets/image/icon/video_play_icon.png" />
            </div>
            <div class="mb-time-box">{{currentTimeString}}/{{totalTimeString}}</div>
            <div
              ref="mobile_time_line"
              class="mb-time-line-box"
              @touchstart="seekStartMobile"
              @touchmove="seekMoveMobile"
              @touchend="seekEnd"
              @mousedown="seekStart"
              @mousemove="seekMove"
              @mouseup="seekEnd"
            >
              <div
                :style="{width:getPlayedWidthMobile('mobile_time_line')+'px'}"
                class="mb-time-line-played"
              ></div>
              <div
                :style="{left:getPlayedWidthMobile('mobile_time_line')+'px'}"
                class="mb-seekingBox"
              ></div>
              <div
                :style="{width: getNotPlayWidthMobile('mobile_time_line')+'px'}"
                class="mb-time-line-not-played"
              ></div>
            </div>
            <div style="margin-left: 0.8rem;" class="mobile-video-icon" @click.stop="voiceOnOrOff">
              <img v-if="voiceOff" src="../../../assets/image/icon/video_voice_off.png" />
              <img v-if="!voiceOff" src="../../../assets/image/icon/video_voice_on.png" />
            </div>
            <div
              class="mobile-video-icon"
              style="margin-right: 0.8rem;margin-left: 0.8rem"
              @click.stop="fullScreenClick('mb_fullscreen', 'mobileVideo'+componentIndex)"
            >
              <img src="../../../assets/image/icon/video_full_screen.png" />
            </div>
          </div>
        </template>
        <blinds v-if="useBYC" />
      </div>
    </div>
  </div>
</template>

<script>
import Blinds from "./Blinds";
import wx from 'weixin-js-sdk'
export default {
  name: "VideoMobile",
  components: { Blinds },
  watch: {
    dragging(newVal) {
      if (newVal) {
        this.playingVideo = false;
      } else {
        this.playingVideo = true;
      }
      const playerLive = document.getElementById(
        "mobileVideo" + this.componentIndex
      );
      if (this.playingVideo) {
        playerLive.play();
      } else {
        playerLive.pause();
      }
    }
  },
  data() {
    return {
      tempCover:'https://oss-cn-shanghai.aliyuncs.com/connectplus/origin/202206/2308ab9daad61eb26909e67ab53703e7.jpeg',
      videoStr: "?vframe/jpg/offset/2",
      playingVideo: true,
      voiceOff: true,
      currentTimeString: "00:00",
      currentTime: 0,
      totalTimeString: "00:00",
      totalTime: 0,
      timeLineClientX: 0,
      dragging: false,
      fullScreen: false,
      showBottomController: false,
      isWechatLike: false,
      isshowplaybtn:true,
      isweixinenv:false,//是否在微信浏览器打开
      isandroid:false,//是否按钮
      version: {
        u: ""
      }
    };
  },
  props: {
    showCom: {
      default: "",
      type: String,
      required: false
    },
    itemIndex: {
      type: Number,
      required: false,
      default: 0
    },
    componentIndex: {
      type: Number,
      required: true
    },
    receiveData: {
      type: null,
      observer: function(newVal, oldVal) {}
    },
    sourceData: {
      default: "",
      type: String,
      required: true
    },
    useBYC: {
      type: Boolean,
      default: false
    },
    useVideoController: {
      type: Boolean,
      default: false
    },
    singlePlay: {
      type: Boolean,
      default: false
    },
    videoHeight: {
      type: Number,
      default: 0
    },
    showControls: {
      type: Boolean,
      default: true
    },
    imgLoaded: {
      type: Boolean,
      default: false,
    }
  },
  mounted() {
    this.isweixinenv=this.$utils.isWeixin();
    this.isandroid=this.$utils.versions().android;
    if(this.isweixinenv){
      this.playingVideo=false;
    }
    this.version = this.$utils.versions();
    if (this.version.u.indexOf("iPhone") > -1) {
      //iphone
      if (this.version.u.indexOf("Safari") == -1) {
        this.isWechatLike = true;
      }
    } else if (this.version.u.indexOf("Mobile") > -1) {
      //安卓
      this.isWechatLike = true;
    }
    console.log(this.isweixinenv,'this.isweixinenv')
    console.log(this.isandroid,'this.isandroid')
    console.log(this.isWechatLike,'this.isWechatLike')
    setTimeout(()=>{
      let videoKey = ["mobileVideo"];
      for (let key in videoKey) {
        let playerLive = document.getElementById(
            videoKey[key] + this.componentIndex
        );
        if (!playerLive) {
          continue;
        }
        playerLive.addEventListener("loadedmetadata", () => {
          this.totalTime = playerLive.duration;
          console.log(playerLive.duration);
          this.totalTimeString = this.formatTime(playerLive.duration);
        });
        playerLive.addEventListener("timeupdate", () => {
          this.totalTime = playerLive.duration;
          this.totalTimeString = this.formatTime(playerLive.duration);
          this.currentTime = playerLive.currentTime;
          this.currentTimeString = this.formatTime(playerLive.currentTime);
        });
        playerLive.addEventListener("play", () => {
          this.playingVideo = true;
        });
        playerLive.addEventListener("pause", () => {
          this.playingVideo = false;
        });
      }
    },1000);
    if(this.isweixinenv&&this.isWechatLike){
        this.$nextTick(()=>{
          this.audioAutoPlay()
        })
    }
    

  },
  methods: {
    audioAutoPlay(id){  
      var audio = document.getElementById(
        "mobileVideo" + this.componentIndex
      );
      document.addEventListener("WeixinJSBridgeReady", function () {  
              audio.play();  
      }, false);  

     
       
     },
    seekStart(event) {
      this.dragging = true;
      let timeLineClientX = this.$refs.mobile_time_line.getBoundingClientRect()
        .x;
      let position = event.clientX - timeLineClientX;
      if (position < 0) {
        position = 0;
      }
      let playerLive = document.getElementById(
        "mobileVideo" + this.componentIndex
      );
      playerLive.currentTime =
        (this.totalTime * position) / this.$refs.mobile_time_line.clientWidth;
    },
    seekMove(event) {
      if (!this.dragging) {
        return;
      }
      let timeLineClientX = this.$refs.mobile_time_line.getBoundingClientRect()
        .x;
      let position = event.clientX - timeLineClientX;
      if (position < 0) {
        position = 0;
      }
      const playerLive = document.getElementById(
        "mobileVideo" + this.componentIndex
      );
      playerLive.currentTime =
        (this.totalTime * position) / this.$refs.mobile_time_line.clientWidth;
    },
    exitFullScreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    },
    fullScreenClick(key, id = '') {
      // console.log(key);
      if (document.fullscreenElement) {
        this.fullScreen = true;
      } else {
        this.fullScreen = false;
      }
      if(id){
        console.log(id);
        let video =  document.getElementById(id);
        if (video.webkitEnterFullScreen) {
          video.webkitEnterFullScreen();
        }
      }
      let player = document.getElementById(key);
      if (this.fullScreen) {
        this.exitFullScreen();
        this.fullScreen = false;
      } else {
        this.fullScreen = true;
        const rfs =
          player.requestFullscreen ||
          player.webkitRequestFullScreen ||
          player.mozRequestFullScreen ||
          player.msRequestFullscreen;
        rfs.call(player);
      }
    },
    voiceOnOrOff() {
      this.voiceOff = !this.voiceOff;
    },
    getPlayedWidthMobile(key) {
      // console.log(key);
      if (this.$refs[key]) {
        let width =
          this.$refs[key].clientWidth * (this.currentTime / this.totalTime);
        // console.log(width);
        // console.log(this.currentTime);
        // console.log(this.totalTime);
        return width;
      }
      return 0;
    },
    getNotPlayWidthMobile(key) {
      console.log(key)
      if (this.$refs[key]) {
        let width =
          this.$refs[key].clientWidth * (this.currentTime / this.totalTime);
        // console.log(width);
        return this.$refs[key].clientWidth - width;
      }
      return 0;
    },
    formatTime(value) {
      let result = parseInt(value);
      let h =
        Math.floor(result / 3600) < 10
          ? "0" + Math.floor(result / 3600)
          : Math.floor(result / 3600);
      let m =
        Math.floor((result / 60) % 60) < 10
          ? "0" + Math.floor((result / 60) % 60)
          : Math.floor((result / 60) % 60);
      let s =
        Math.floor(result % 60) < 10
          ? "0" + Math.floor(result % 60)
          : Math.floor(result % 60);
      result = `${h}:${m}:${s}`;
      return result;
    },
    seekEnd(event) {
      this.dragging = false;
    },
    seekStartMobile(event) {
      this.dragging = true;
      let timeLineClientX = this.$refs.mobile_time_line.getBoundingClientRect()
        .x;
      let position = event.changedTouches[0].clientX - timeLineClientX;
      if (position < 0) {
        position = 0;
      }
      const playerLive = document.getElementById(
        "mobileVideo" + this.componentIndex
      );
      playerLive.currentTime =
        (this.totalTime * position) / this.$refs.mobile_time_line.clientWidth;
      this.doShowBottomClick();
    },
    seekMoveMobile(event) {
      if (!this.dragging) {
        return;
      }
      let timeLineClientX = this.$refs.mobile_time_line.getBoundingClientRect()
        .x;
      let position = event.changedTouches[0].clientX - timeLineClientX;
      if (position < 0) {
        position = 0;
      }
      const playerLive = document.getElementById(
        "mobileVideo" + this.componentIndex
      );
      playerLive.currentTime =
        (this.totalTime * position) / this.$refs.mobile_time_line.clientWidth;
      this.doShowBottomClick();
    },
    playOrPauseClick(key,type) {
      const playerLive = document.getElementById(key);
      // if(type==1){
      //   playerLive.play();
      // }
      this.isshowplaybtn=false;
      if (this.playingVideo) {
        playerLive.pause();
      } else {
        playerLive.play();
      }
    },
    doShowBottomClick(id) {
      this.showBottomController = true;
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.showBottomController = false;
      }, 3000);
    },
    goPlayVideo(id){
      let playing=false;
      if(this.isweixinenv){
        const playerLive = document.getElementById('mobileVideo'+id);
        if(!playing){
          playerLive.play();
          playing=true;
        }else{
          playerLive.pause();
          playing=false
        }
        console.log(playerLive,'playerLive')
        
      }
    }
  }
};
</script>

<style scoped lang="less">
.my-mobile-video-class {
  // height: 100%;
  width: 100%;
}
.viedoplay{
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index:10;
  .flex{
     width: 100%;
     height:100%;
     display: flex;
     align-items:center;
     justify-content: center;
    .viedoplayicon{
    width: 60px;
    height: 60px;
  }
  }
  

}
</style>



// WEBPACK FOOTER //
// src/components/common/customize/VideoMobile.vue